import styles from "./styles.module.scss";

import phoneImg from "../../assets/phone.svg";
import linkedinImg from "../../assets/linkedin.svg";
import emailImg from "../../assets/email.svg";
import githubImg from "../../assets/github.svg";

export function Contact() {
  return (
    <section id="srollSuave">
      <div className={styles.ContactTitle}>
        <h2 className="subtitle">
          Vamos bater um papo <span>?</span>
        </h2>
      </div>
      <div className={styles.ContactContainer}>
        <h3>Contato 💻</h3>
        <div>
          <address>
            <a href="tel:+5543996909488">
              <img src={phoneImg} alt="" />+ 55 43 99690-9488
            </a>
            <a href="mailto:welissonh80@gmail.com">
              <img src={emailImg} alt="Email" />
              contato@welisson.com
            </a>
            <a href="https://www.linkedin.com/in/wellissonhenriques21/">
              <img src={linkedinImg} alt="Linkedin" />
              Meu Linkedin
            </a>
            <a href="https://github.com/wellhenrique">
              <img src={githubImg} alt="Github" />
              Meu Github
            </a>
          </address>
        </div>
      </div>
    </section>
  );
}
